import React, { useContext, useState } from 'react';
import Flags from 'country-flag-icons/react/3x2';

import { TextdomainContext } from 'react-gettext';
// @ts-ignore
import logoWhite from '../images/ntnu_logo_white.png';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {SvgIcon} from "@mui/material";

interface myProps {
    selectLang: Function
}

const MainMenu: React.FC<myProps> = (props) => {
    const { selectLang } = props;
    const { gettext } = useContext(TextdomainContext);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const menuIsOpen = Boolean(anchorEl);
    const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    return (
      <Box sx={{flexGrow: 1}}>
          <AppBar position="static">
              <Toolbar
                style={{backgroundColor: '#00509e'}}
              >
                <Box display='flex' flexGrow={1}>
                  <Typography>
                    <img src={logoWhite} alt="NTNU logo" />
                    {' '}
                    {gettext('FVO databaser driftet av Fakutet for medisin og helsevitenskap')}.
                  </Typography>
                </Box>
                  <IconButton
                    size="large"
                    edge="end"
                    color="inherit"
                    aria-label="menu"
                    sx={{ mr: 2 }}
                    onClick={handleMenuOpen}
                  >
                      <MenuIcon />
                  </IconButton>
                  <Menu open={menuIsOpen} anchorEl={anchorEl}>
                      <MenuItem
                        id="button-english"
                        onClick={() => {
                            selectLang('en_GB');
                            handleMenuClose();
                        }}
                      >
                        <SvgIcon><Flags.GB title="United States" /></SvgIcon>
                        { ' '}
                        {gettext('Engelsk')}
                      </MenuItem>
                      <MenuItem
                        id="button-norwegian"
                        onClick={() => {
                            selectLang('nb_NO');
                            handleMenuClose();
                        }}
                      >
                        <SvgIcon><Flags.NO title="Norge"/></SvgIcon>
                        {' '}
                        {gettext('Norsk')}
                      </MenuItem>
                  </Menu>
              </Toolbar>
          </AppBar>
      </Box>

    );
};

export default MainMenu;
